import { useCallback } from 'react';
import useLocalStorageState from 'use-local-storage-state';

import { type BuildSchemaOutputType } from '../form/schema';

export const PersistBuildVersion = '5.0';

export type PersistBuildFormType = {
  version: string;
  data: undefined | Partial<BuildSchemaOutputType>;
  timeStamp: number;
};

const defaultValue: PersistBuildFormType = {
  version: PersistBuildVersion,
  data: undefined,
  timeStamp: 0,
};

export const usePersistBuildForm = () => {
  // 빌드 페이지 개선을 진행하며 스키마 / 폼데이터 간 layer 관계를 변경하여
  // 기존 로컬스토리지에 저장된 값과 현재 폼데이터 키 간 불일치가 발생하여
  // 로컬스토리지에 저장하는 스키마 버전을 업데이트합니다.
  const [persistData, _setPersist] = useLocalStorageState('quiz_build_v4', {
    defaultValue,
  });

  const clearPersist = () => {
    _setPersist(defaultValue);
  };

  const updatePersistData = useCallback(
    (data: Partial<BuildSchemaOutputType>) => {
      _setPersist({
        version: defaultValue.version,
        timeStamp: Date.now(),
        data,
      });
    },
    [_setPersist],
  );

  return {
    updatePersistData,
    persistData,
    clearPersist,
  };
};
